export const buttonBorderWidth: number = 1; // the border width on a base button
